/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

const version = '__buildVersion__';

// configuration
export { AnalyticsReporterConfiguration } from './internal/configuration/AnalyticsReporterConfiguration';
export { ConvivaAnalyticsReporterConfiguration } from './internal/configuration/ConvivaAnalyticsReporterConfiguration';
export { DatazoomAnalyticsReporterConfiguration } from './internal/configuration/DatazoomAnalyticsReporterConfiguration';
export { NewRelicAnalyticsReporterConfiguration } from './internal/configuration/NewRelicAnalyticsReporterConfiguration';
export { GodavariAnalyticsReporterConfiguration } from './internal/configuration/GodavariAnalyticsReporterConfiguration';

export {
  NPAWAnalyticsReporterConfiguration,
  NPAWLogLevel,
} from './internal/configuration/NPAWAnalyticsReporterConfiguration';
// internal
export { Provider } from './internal/Provider';
export { ErrorSeverity } from './internal/ErrorSeverity';

// models
export { PlaybackEndReason } from './model/PlaybackEndReason';
export { PlaybackStartupObservation, PlaybackStartupMilestone } from './model/PlaybackStartupObservation';
export {
  MediaFlow,
  MediaFlowKind,
  MediaStep,
  MediaStepEndOptions,
  MediaStepName,
  MediaStepOptions,
} from './model/MediaFlow';
export { AdMetadata } from './model/AdMetadata';
export { Application } from './model/Application';
export { ApplicationContainer } from './model/ApplicationContainer';
export { ApplicationError } from './model/ApplicationError';
export { ApplicationSharePlatform } from './model/ApplicationSharePlatform';
export { Content, PlaybackType } from './model/Content';
export { CustomEvent } from './model/CustomEvent';
export { Device } from './model/Device';
export { Playback } from './model/Playback';
export { PlaybackError } from './model/PlaybackError';
export { SportContent } from './model/SportContent';
export { SportVenue } from './model/SportVenue';
export { Subscription } from './model/Subscription';
export { TVShow } from './model/TVShow';
export { User } from './model/User';
export { UserError } from './model/UserError';
export { ApplicationMetrics } from './model/ApplicationMetrics';

// sessions
export { ApplicationSession } from './session/ApplicationSession';
export { PlaybackSession } from './session/PlaybackSession';
export { UserSession } from './session/UserSession';

// factories
export { getApplicationSession } from './AnalyticsFactory';

// types
export { AdTechnology } from './type/AdTechnology';
export { DeviceCategory } from './type/DeviceCategory';
export { DeviceType } from './type/DeviceType';
export { PlatformName } from './type/PlatformName';
export { PlatformType } from './type/PlatformType';
export { PlaybackSourceTypes, PlaybackSourceType } from './type/PlaybackSourceType';
export { StreamType } from './type/StreamType';
export { SubscriptionStatus } from './type/SubscriptionStatus';
export { UserType } from './type/UserType';

// others
export { version };
